@if (isUserOnPlayBreak$ | async) {
    <span class="safergambling-icon-editmybet" (click)="$event.stopPropagation()">
        <vn-icon class="editmybet-arc-icon" name="theme-arc" size="14" />
    </span>
}

<button
    ds-button
    msThemedButton
    size="small"
    class="mybets-edit-bet-button"
    [kind]="buttonKind"
    [variant]="buttonVariant"
    [themeVariant]="buttonThemeVariant"
    [themeKind]="buttonThemeKind"
    [disabled]="!isEnabled"
    [ngClass]="{ 'edit-bet-button': enableRedesignedBetCard }"
    (click)="click($event)">
    {{ sitecoreMyBets.myBets.EditBetButtonText }}
    @if (!isEpcotEnabled && isEnabled) {
        <vn-icon slot="end" size="10" name="theme-edit" />
    }
    @if (!isEpcotEnabled && !isEnabled) {
        <vn-icon slot="end" size="10" name="theme-locked-i" />
    }
</button>
